import { render, staticRenderFns } from "./Stopwatch.vue?vue&type=template&id=38070420&"
import script from "./Stopwatch.vue?vue&type=script&lang=js&"
export * from "./Stopwatch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports